// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"372":"cards","517":"calendar","552":"rules","774":"raspisanie","866":"partners","962":"home"}[chunkId] || chunkId) + "." + {"229":"27f42aab","372":"baf0c19f","517":"40ef76a0","552":"22cf32e1","774":"6a296cc3","866":"755f2390","962":"ad2396eb"}[chunkId] + ".js";
};